import * as maplibregl from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url";

// Vite's bundle does not leave import.meta.url pointing at the worker file.
// ?worker&url emits one self-contained chunk, which the worker can load.
let workerConfigured = false;

// The React binding constructs MapLibre itself, so it has to call this before
// its first map. Vite's worker chunk is not the URL MapLibre would derive.
export function ensureMapWorker(): void {
  if (workerConfigured) return;
  maplibregl.setWorkerUrl(workerUrl);
  workerConfigured = true;
}

export function createMap(
  options: maplibregl.MapOptions,
): maplibregl.Map | null {
  ensureMapWorker();
  try {
    return new maplibregl.Map({
      ...options,
      // Overscale every level past the source max zoom. Zone clicks and
      // polygon labels read queryRenderedFeatures, which follows this value.
      zoomLevelsToOverscale: undefined,
    });
  } catch (err) {
    if (err instanceof maplibregl.GPUInitializationError) return null;
    throw err;
  }
}

export function MapGpuNotice({ className = "" }: { className?: string }) {
  return (
    <div
      className={`flex items-center justify-center p-4 text-center text-[12px] text-muted ${className}`}
      role="alert"
    >
      This map needs WebGL 2.
    </div>
  );
}
